import { CollabImagesServiceV2 } from "./service";
const map = new Map();
const key = "collab-images/ping";
export function startPing(url, roomId) {
    if (map.has(key)) {
        console.warn(`[PING] Interval with key "${key}" already running`);
        return;
    }
    const id = setInterval(async () => {
        try {
            await new CollabImagesServiceV2(url).pingGroup(roomId);
        }
        catch (e) {
            console.log(`[PING] Error in ping`);
        }
    }, 1000 * 60);
    map.set(key, id);
}
export function stopPing() {
    const id = map.get(key);
    if (id) {
        clearInterval(id);
        map.delete(key);
    }
}
